import {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect
} from 'react';
import { useIntl } from 'react-intl';
import {
  Switch,
  BrowserRouter as Router,
  useHistory,
} from 'react-router-dom';
import { styled } from '@mui/material/styles';

import {
  RouteC,
  PrivateRouteC,
} from '../../components/Routes';
import HomePage from '../HomePage/Loadable';
import RegisterPage from '../RegisterPage/Loadable';
import Test from '../Test/Loadable';
import RegisterWithFacebookPage from '../RegisterWithFacebookPage/Loadable';
import RegisterWithLinePage from '../RegisterWithLinePage/Loadable';
import RegisterWithGooglePage from '../RegisterWithGooglePage/Loadable';
import RegisterWithApplePage from '../RegisterWithApplePage/Loadable';
import NotFoundPage from '../NotFoundPage/Loadable';
import RegisterSuccessPage from '../RegisterSuccessPage/Loadable';
import LoginPage from '../LoginPage/Loadable';
import ForgotPasswordPage from '../ForgotPasswordPage/Loadable';
import ForgotPasswordSuccessPage from '../ForgotPasswordSuccessPage/Loadable';
import ResetPasswordPage from '../ResetPasswordPage/Loadable';
import ResetPasswordSuccessPage from '../ResetPasswordSuccessPage/Loadable';
import EditProfilePage from '../EditProfilePage/Loadable';
import TicketBookingPage from '../TicketBookingPage/Loadable';
import TicketListPage from '../TicketListPage/Loadable';
import TicketDetailPage from '../TicketDetailPage/Loadable';
import BookingDetailPage from '../BookingDetailPage/Loadable';
import TicketQRPage from '../TicketQRPage/Loadable';
import MyPocketPage from '../MyPocketPage/Loadable'
import MyPocketTopupPage from '../MyPocketTopupPage/Loadable'
import MyPocketTransferWristbandPage from '../MyPocketTransferWristbandPage/Loadable'
import MyPocketPaymentHistoryPage from '../MyPocketPaymentHistoryPage/Loadable'
import MyPocketPaymentHistoryIdPage from '../MyPocketPaymentHistoryIdPage/Loadable'
import GoogleCallback from '../SocialCallback/GoogleCallback';
import LineCallback from '../SocialCallback/LineCallback';
import FacebookCallback from '../SocialCallback/FacebookCallback';
import AppleCallback from '../SocialCallback/AppleCallback';
import TreasureHuntPage from '../TreasureHuntPage/Loadable'
import TreasureHuntHowToPlayPage from '../TreasureHuntHowToPlayPage/Loadable'
import DiscoveryPage from '../DiscoveryPage/Loadable';
import DiscoveryDetailPage from '../DiscoveryDetailPage/Loadable';
import DiscoveryStore from '../../stores/Discovery';
import PrivacyPage from '../PrivacyPage/Loadable';

import {
  Badge,
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Paper
} from '@mui/material';

import userStore from '../../stores/User';
import localeStore from '../../stores/Locale';
import navBarStore from '../../stores/NavBar';
import LogoutAutoPage from '../LogoutAutoPage';

const SwitchX = () => {

  const user = userStore();
  const navBar = navBarStore();

  const haveToken = () => {
    return user.accessToken !== null;
  }

  const haveResetPasswordToken = () => {
    return true; //@TODO
  }

  const isResetPasswordSuccess = () => {
    return true; //@TODO
  }

  const selectTabMyTciket = () => navBar.selectMenu(1);

  return (
    <Switch>
      <RouteC exact path="/" component={HomePage} />
      <RouteC exact path="/test" component={Test} />
      <RouteC exact path="/register" component={RegisterPage} fullscreen/>
      <RouteC exact path="/register/facebook" component={RegisterWithFacebookPage} fullscreen/>
      <RouteC exact path="/register/google" component={RegisterWithGooglePage} fullscreen/>
      <RouteC exact path="/register/line" component={RegisterWithLinePage} fullscreen/>
      <RouteC exact path="/register/apple" component={RegisterWithApplePage} fullscreen/>
      <RouteC exact path="/google/callback" component={GoogleCallback} fullscreen/>
      <RouteC exact path="/line/callback" component={LineCallback} fullscreen/>
      <RouteC exact path="/facebook/callback" component={FacebookCallback} fullscreen/>
      <RouteC exact path="/apple/callback" component={AppleCallback} fullscreen/>
      <RouteC exact path="/register-success" component={RegisterSuccessPage} fullscreen/>
      <RouteC exact path="/login" component={LoginPage} fullscreen/>
      <RouteC exact path="/logout" component={LogoutAutoPage} fullscreen/>
      <RouteC exact path="/forgot-password" component={ForgotPasswordPage} fullscreen/>
      <RouteC exact path="/forgot-password-success" component={ForgotPasswordSuccessPage} fullscreen/>
      <RouteC exact path="/ticket-booking" component={TicketBookingPage} fullscreen/>
      <RouteC exact path="/ticket-booking/:ticketType" component={TicketBookingPage} fullscreen/>
      <RouteC exact path="/ticket-list" component={TicketListPage} beforeGo={selectTabMyTciket}/>
      <RouteC exact path="/ticket-detail/:bookingId" component={TicketDetailPage} fullscreen/>
      <RouteC exact path="/booking-detail/:bookingId" component={BookingDetailPage} fullscreen/>
      <RouteC exact path="/ticket-qr/:ticketId" component={TicketQRPage} fullscreen/>
      <PrivateRouteC _if={haveToken} exact path="/me" component={HomePage} fullscreen/>
      <PrivateRouteC _if={haveToken} exact path="/edit-profile" component={EditProfilePage} fullscreen/>
      <PrivateRouteC _if={haveResetPasswordToken} exact path="/reset-password" component={ResetPasswordPage} fullscreen/>
      <PrivateRouteC _if={isResetPasswordSuccess} exact path="/reset-password-success" component={ResetPasswordSuccessPage} fullscreen/>
      <RouteC exact path="/my-pocket" component={MyPocketPage} />
      <RouteC exact path="/my-pocket/top-up" component={MyPocketTopupPage} fullscreen />
      <RouteC exact path="/my-pocket/my-payment-history" component={MyPocketPaymentHistoryPage} fullscreen />
      <RouteC exact path="/my-pocket/payment-history/:id" component={MyPocketPaymentHistoryIdPage} fullscreen />
      <RouteC exact path="/my-pocket/tranfer/:id" component={MyPocketTransferWristbandPage} fullscreen />
      <RouteC exact path="/treasure-hunt" component={TreasureHuntPage} fullscreen/>
      <RouteC exact path="/treasure-hunt/how-to-play" component={TreasureHuntHowToPlayPage} fullscreen/>
      <RouteC exact path="/discovery-detail/:id" component={DiscoveryDetailPage}/>
      <RouteC exact path="/discoveries" component={DiscoveryPage}/>
      <RouteC exact path="/privacy" component={PrivacyPage} fullscreen/>
      <RouteC component={NotFoundPage} />
    </Switch>
  );
}

const ButtomNavBar = forwardRef((props, ref) => {

  const discoveryStore = DiscoveryStore();
  const discoveries = DiscoveryStore(state => state.discoveries);
  const user = userStore();
  const intl = useIntl();
  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: -3,
      top: 6
    },
  }));

  useEffect(() => {
    if (user.profile !== null) {
      discoveryStore.getDiscoveries();
    }
  }, [])

  const history = useHistory();
  const navBar = navBarStore();

  const handleClick = (location) => {
    history.push(location);
  }

  const getIcon = (menu) => {
    if (menu.name == "Discovery") {
      const badgeCount = discoveries.filter(dis => dis.isRead === false).length;
      return <StyledBadge badgeContent={badgeCount} color="error">{menu.icon}</StyledBadge> //<Badge badgeContent={4} color="error">{menu.icon}</Badge>
    } else {
      return menu.icon
    }
  }

  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
      <BottomNavigation
        showLabels
        value={navBar.selectedIndex}
        onChange={(event, newValue) => {
          navBar.selectMenu(newValue);
        }}
      >
        {
          props.menu.map(m =>
            <BottomNavigationAction
              key={m.name}
              label={intl.formatMessage(m.intl)}
              icon={getIcon(m)}
              onClick={() => handleClick(m.location)}
            />
          )
        }
      </BottomNavigation>
    </Paper>
  );
});

const App = () => {

  const navBar = navBarStore();
  const ref = useRef(null)
  const user = userStore();
  const locale = localeStore();

  useEffect(() => {
    locale.sendLanguageToNative();
    user.sendAccessTokenToNative();
  }, []);

  return (
    <Router>
      <Box sx={{ pb: 7 }} ref={ref}>
        <SwitchX />
        {
          navBar.isShow ?
            <ButtomNavBar
              menu={navBar.menu}
            />
            : null
        }
      </Box>
    </Router>
  );

};

export default App;